import React from 'react';
import {BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';
import Header from './components/Header/Header';
import {PATH} from './constants';
import LoginPage from './pages/LoginPage';
import ProductManagementPage from './pages/ProductManagementPage';
import Footer from './components/Footer';
import AccountSettingPage from './pages/AccountSettingPage';
import CreateProductPage from "./pages/CreateProductPage";
import StoreInfoPage from "./pages/StoreInfoPage";
import OnboardingPage from "./pages/OnboardingPage";
import EditProductPage from "./pages/EditProductPage";
import Navbar from "./components/Navbar";
import {isMobile} from "react-device-detect";
import AccountPage from "./pages/AccountPage";
import SharePage from "./pages/SharePage";
import OrdersPage from "./pages/OrdersPage";
import OrderDetails from "./components/Order/OrderDetails";
import {clsx} from "clsx";
import AddressPage from "./pages/AddressPage";
import HomePage from "./pages/HomePage";
import NotificationPage from './pages/NotificationPage';
import ShippingConfigPage from "./pages/ShippingConfigPage";

const AppRouter = () => {
    return (
        <Router>
            <div className="font-default bg-[#EDEDED] md:bg-[#FAFAFC]">
                <Header/>
                <Routes>
                    <Route path={PATH.LOGIN} element={<LoginPage/>}/>
                    <Route path={PATH.ONBOARDING} element={<OnboardingPage/>}/>
                </Routes>
                <Content/>
                <Footer/>
            </div>
        </Router>
    );
};

const Content = () => {
    const location = useLocation();
    if (location.pathname === PATH.LOGIN || location.pathname === PATH.ONBOARDING) {
        return null;
    }
    return (
        <div
            className={clsx(location.pathname === PATH.BUYER_MANAGEMENT_CART_DETAIL ? '!pt-0 md:!pt-[90px]' : '', 'fn-page')}>
            {!isMobile && (
                <div className='section-left'>
                    <Navbar/>
                </div>
            )}

            <div className='section-right'>
                <Routes path="*" element={<Content/>}>
                    <Route path={PATH.HOME} element={<HomePage/>}/>
                    <Route path={PATH.MANAGING_PRODUCT} element={<ProductManagementPage/>}/>
                    <Route path={PATH.MANAGING_ORDER} element={<OrdersPage/>}/>
                    <Route path={PATH.BUYER_MANAGEMENT_CART_DETAIL} element={<OrderDetails/>}/>
                    <Route path={PATH.STORE_INFO} element={<StoreInfoPage/>}/>
                    <Route path={PATH.CREATE_PRODUCT} element={<CreateProductPage/>}/>
                    <Route path={PATH.EDIT_PRODUCT + '/:productId'} element={<EditProductPage/>}/>
                    <Route path={PATH.ACCOUNT_SETTING} element={<AccountSettingPage/>}/>
                    <Route path={PATH.CHANGE_PASSWORD} element={<AccountPage/>}/>
                    <Route path={PATH.SHARE} element={<SharePage/>}/>
                    <Route path={PATH.ADDRESS} element={<AddressPage/>}/>
                    <Route path={PATH.NOTIFICATION} element={<NotificationPage/>}/>
                    <Route path={PATH.SHIPPING_CONFIG} element={<ShippingConfigPage/>}/>
                </Routes>
            </div>
        </div>
    );
};

export default AppRouter;
